module.exports = __webpack_public_path__ + "static/media/Close_blue_withoutCircle.af0d59e9.svg";